import axios from 'axios';
import { HTTPError } from '../interfaces';

export function isHTTPError(e: unknown): e is HTTPError {
  return axios.isAxiosError(e);
}
